var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "item-list" },
    _vm._l(_vm.items, function (item) {
      return _c("voice-mail-item", {
        key: item.id,
        staticClass: "item-list__item voice-message-pick-list__item",
        attrs: { item: item, active: _vm.active },
        on: { select: _vm.select },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }